import {
    Text,
    Button,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    // CheckboxGroup,
    Input,
    FormControl,
    FormLabel,
    OrderedList,
    ListItem,
    UnorderedList,
    // TableContainer,
    // IconButton,
  } from "@chakra-ui/react";
  
  import React, { useEffect, useState } from "react";
  import Strings from '../config/Strings';
  
  
  export default function ContractIntroAlert({ onCompleted, disclosure }) {
    return (
      <AlertDialog
        // size={""}
        size={"lg"}
        
        isOpen={disclosure.isOpen}
        closeOnOverlayClick={true}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {Strings.app.dialog.contract_intro.title}
            </AlertDialogHeader>
  
            <AlertDialogBody fontSize={"sm"}>
              <Text fontWeight={"bold"}>
              {Strings.app.dialog.contract_intro.content1}
              </Text>
  
              <Text>
              <br />
              
              {Strings.app.dialog.contract_intro.content2}
              </Text>
  
              <Text fontWeight={"bold"}><br />
              {Strings.app.dialog.contract_intro.content3}</Text><br />
              <OrderedList>
                <ListItem key="contract-intor-key1">
                  <Text dangerouslySetInnerHTML={{__html: Strings.app.dialog.contract_intro.content4}}>
                  </Text>
                </ListItem>
                <ListItem  key="contract-intor-key2">
  
                <Text dangerouslySetInnerHTML={{__html: Strings.app.dialog.contract_intro.content5}}>
                  </Text>
                </ListItem>
  
                <ListItem  key="contract-intor-key3">
  
                <Text dangerouslySetInnerHTML={{__html: Strings.app.dialog.contract_intro.content6}}>
                  </Text>
                </ListItem>
  
              </OrderedList>
  
              <Text fontWeight={"bold"}>
              <br />{Strings.app.dialog.contract_intro.content7}
              </Text><br />
  
              <UnorderedList>
                <ListItem key="contract-intor-key4">
                  <Text dangerouslySetInnerHTML={{__html: Strings.app.dialog.contract_intro.content8}}>
                  </Text>
                </ListItem>
                <ListItem key="contract-intor-key5">
  
                <Text dangerouslySetInnerHTML={{__html: Strings.app.dialog.contract_intro.content9}}>
                  </Text>
                </ListItem>
              </UnorderedList>
  
              <Text fontWeight={"bold"}><br />{Strings.app.dialog.contract_intro.content10}</Text>
            </AlertDialogBody>
  
            <AlertDialogFooter>
              <Button
                mr={4}
                colorScheme={"green"}
                onClick={() => {
                  onCompleted(false);
                  disclosure.onClose();
                }}
              >
                {Strings.app.dialog.contract_intro.next}
              </Button>
  
              <Button
                mr={4}
                colorScheme={"red"}
                onClick={() => {
                  onCompleted(true);
                  disclosure.onClose();
                }}
              >
                {Strings.app.dialog.contract_intro.cancel}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  }
  